import axios from "axios";
import settings from "utils/settings";
import filterTypes from "data/filter-types";

const apiUrl = `${settings.apiUrl}api/`;

export const requestActionNoPagination = (filters) =>
  axios.post(`${apiUrl}trip/list`, {
    criteria: filters
  });

export const requestActionPaymentStatus = () =>
  axios.get(`${apiUrl}trip/payment-status`);

export const requestActionTaskTypes = () =>
  axios.get(`${apiUrl}trip/task-types`);

export const requestActionGetTripById = (bikeId, startDate, endDate) =>
  axios.post(`${apiUrl}trackings/list`, {
    criteria: [{
      fieldName: "bike",
      fieldValue: bikeId,
      searchOperation: filterTypes.EQUALS.value
    }, {
      fieldName: "date",
      fieldValue: [startDate, endDate],
      searchOperation: filterTypes.BETWEEN.value
    }]
  });

export const requestActionEditDuration = (id, minutes) =>
  axios.get(`${apiUrl}trip/edit-duration/${id}/${minutes}`);



// WEBPACK FOOTER //
// ./src/actions/action/requests.js